import { ErrorHandler, Injectable } from '@angular/core';
import { LogService } from './log.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private loggingService: LogService) {}

  handleError(error: any): void {
    this.loggingService.error('GlobalErrorHandler', error);
  }
}
